import WarningIcon from '@mui/icons-material/Warning';

export const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
        field: 'status',
        headerName: 'Status',
        width: 200,
        renderCell: (params) => {
          const { days_passed, status } = params.row;
    
          let icon = null;
          let iconStyle = {};
    
          if (status !== 'Contact') {
            if (days_passed >= 5) {
              icon = <WarningIcon sx={{ color: '#f44336' }} />;
            } else if (days_passed === 4 || days_passed === 3) {
              icon = <WarningIcon sx={{ color: '#ffa726' }} />;
            } else if (days_passed === 2) {
              icon = <WarningIcon sx={{ color: '#ffeb3b' }} />;
            }
          }
    
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {params.value}
              {icon && (
                <div
                  style={{
                    ...iconStyle,
                    borderRadius: '50%',
                    width: 24,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: 8,
                  }}
                >
                  {icon}
                </div>
              )}
            </div>
          );
        },
      },
    { field: 'patientName', headerName: 'Patient Name', width: 200 },
    { field: 'age', headerName: 'Age', width: 200 },
    { field: 'admit_date', headerName: 'Admit Date', width: 200 },
    { field: 'discharge_date', headerName: 'Discharge Date', width: 200 },
    { field: 'days_passed', headerName: 'Days Passed', width: 200 },
    { field: 'last_visit', headerName: 'Last Visit', width: 200 },
    ];
  
export const rows = [
    { id: 1, patientName: 'MAYNE, FRANCES', age: 27, admit_date: '12/23/2023', discharge_date: '12/26/2023', days_passed: 3, last_visit: '01/10/2024', status: 'Discharged' },
    { id: 2, patientName: 'DANIEL, CHILL', age: 38, admit_date: '12/15/2023', discharge_date: '12/22/2023', days_passed: 7, last_visit: '01/10/2024', status: 'Discharged' },
    { id: 3, patientName: 'BECKER, EPHRAIM', age: 31, admit_date: '12/17/2023', discharge_date: '12/22/2023', days_passed: 5, last_visit: '01/10/2024', status: 'Discharged' },
    { id: 4, patientName: 'LEONARD, JULIAN', age: 62, admit_date: '12/19/2023', discharge_date: '12/24/2023', days_passed: 5, last_visit: '01/10/2024', status: 'Discharged' },
    { id: 5, patientName: 'VANDERBILT, BRIAN', age: 23, admit_date: '12/20/2023', discharge_date: '12/25/2023', days_passed: 1, last_visit: '01/10/2024', status: 'Discharged' },
    { id: 6, patientName: 'CORNEJO, JOSHUA', age: 27, admit_date: '12/20/2023', discharge_date: '12/24/2023', days_passed: 4, last_visit: '01/10/2024', status: 'Contact' },
];

export const columnsHighCost = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'Update', headerName: 'Update', width: 200 },
    { field: 'patientName', headerName: 'Patient Name', width: 200 },
    { field: 'age', headerName: 'Age', width: 200 },
    { field: 'admit_date', headerName: 'Admit Date', width: 200 },
    { field: 'Isurance_Status', headerName: 'Isurance Status', width: 200 },
    { field: 'Total_Cost', headerName: 'Total Cost', width: 200 },
    { field: 'Inpatient_Cost', headerName: 'Inpatient Cos', width: 200 },
    ];
  
export const rowsHighCost = [
    { id: 1, patientName: 'Julian Lopez', age: 27, admit_date: '12/23/2023', Isurance_Status: 'ACTV', Total_Cost: 225055, Inpatient_Cost: 159846, Update: '19/07/2024' },
    { id: 2, patientName: 'Camilo Ruiz', age: 38, admit_date: '12/15/2023', Isurance_Status: 'ACTV', Total_Cost: 151871, Inpatient_Cost: 136408, Update:  '19/09/2024' },
    { id: 3, patientName: 'Andrea Gomez', age: 31, admit_date: '12/17/2023', Isurance_Status: 'INACTY', Total_Cost: 144041, Inpatient_Cost: 120041, Update:  '124/07/2024'},
    { id: 4, patientName: 'Maria, Franco', age: 62, admit_date: '12/19/2023', Isurance_Status: '12/24/2023', Total_Cost: 125041, Inpatient_Cost: 110041, Update:  '12/03/2024' },
    { id: 5, patientName: 'Juliana, Duque', age: 23, admit_date: '12/20/2023', Isurance_Status: 'ACTV', Total_Cost: 114041, Inpatient_Cost: 94041, Update:  '30/11/2024' },
    { id: 6, patientName: 'Pedro, Sanchez', age: 27, admit_date: '12/20/2023', Isurance_Status: 'INACTY', Total_Cost: 94041, Inpatient_Cost: 80041, Update:  '28/06/2024' },
];

export const Status = [ 'ADDRESSED BY PROVIDER','ALREADY HAS AN APPOINTME NT','CARE PLAN ESTABLISHED','CLOSED','CLOSED ON AVILITY','DECEASED','DOCTORS INFORMATION','FAILED TO ADDRESS','NO PHONE NUMBER/WRONG NUMBER','NOT QUALIFIED','IN PROGRESS','OPEN','OTHER LENGUAGE','OUT OF SERVICE AREA','PATIENT CAME IN-NOT ADDRES SED BY PCP','PATIENT ON ANOTHER CARRIER','PENDING','REFUSED','REFUSED TO AGENCY','RELOCATED','RELOCATED','SCHEDULED APPOINTMENT','SUBMITTED','UNABLE TO CONTACT','VISIT AT HOME','CANCELLED INSURANCE','OUTDATED INFO','WRONG INSURANCE NUMBER', 'NOTES SIGNED BY DOCTOR','NOTES NOT SIGNED BY DOCTOR','CHARGE SLIP COMPLETED','CHARGE SLIP NOT COMPLETED','NOT ADDRESSED','COMPLETE','PATIENT NOT IN ROSTER' ]
export const urgency_levels = ["Low", "Medium", "High", "Critical"]
export const icd10_codes = ["E11.9", "I10", "J45.909", "M54.5", "N18.9"]
export const specialist_types = [
    "Cardiologist", "Endocrinologist", "Dermatologist", "Neurologist", "Orthopedic", "Psychiatrist"
]
export const centers = [
    'FortMyers', 'FortPierce', 'Immokalee', 'LakeWorth',
    'Lehigh', 'Naples', 'PortSaintLucie'
]